export enum MetricType {
    MALWARE_DETECTION = 'malwareDetection',
    SUPPORTED_OS = 'osSupported',
    PRIVILEGED_ACCOUNTS = 'priviligedAccounts',
    REMOVABLE_CONTROLS = 'removableControls',
    SECURITY_TOOLS = 'securityTools',
    ACCESS_CONTROLS = 'accessControls',
    PROTECTION = 'protection',
    MALWARE_DEFINITION = 'malwareDefinition',
    OS_SECURITY_PATCHES = 'osSecurityPatches',
    ASSET_ONLINE = 'assetOnline',
    MAINTENANCE = 'maintenance',
    USB_STORAGE = 'usbStorage',
    MOBILE_DEVICES = 'mobileDevices',
    HOTSPOT_MODE = 'hotspotMode',
    WIRELESS_CONNECTIVITY = 'wirelessConnection',
    ADMIN_LOGON = 'adminLogons',
    PORTABLE_SOFTWARE = 'portableSoftware',
    BEHAVIOUR = 'behaviour',
}
